class SliderFilter {
	constructor(config) {
		this.config = Object.assign({
			scope: 'input[type="range"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('input', function() {
			let left = (this.value / $(this).attr('max') * 100);
			$(this).parent().find('.output__wrapper').css('left', left + '%');
			$(this).parent().find('.output__wrapper').css('transform', 'translateX(-'+left+'%'+')');
			$(this).parent().find('div.output__wrapper output').text(this.value);
		}).trigger('input');

		this.$scope.on('mouseenter', (e) => {
			$(e.currentTarget).next().stop().fadeIn('fast');
		});

		this.$scope.on('mouseleave', (e) => {
			$(e.currentTarget).next().stop().fadeOut('fast');
		});
	}
}

export default SliderFilter;